// aptoken/frontend/src/App.js

import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HeaderToken, Footer, WalletProvider } from "@dsc/ui/token"; 
import "@dsc/ui/header.css"

// Components
import MintApToken from "./components/MintApToken";
import RecordEvent from "./components/RecordEvent";
import ViewToken from "./components/ViewToken";
import TokenDetail from "./components/TokenDetail";
import TrackProvenance from "./components/TrackProvenance";
import ApTokenCollection from "./components/ApTokenCollection";

const App = () => {
  return (
    // ✅ Wrap the entire app inside WalletProvider
    <WalletProvider>
      <Router>
        {/* Header for ApToken */}
        <HeaderToken appType="aptoken" />

        <div className="container" style={{ padding: "20px" }}>
          <Routes>
            {/* Home route */}
            <Route
              path="/"
              element={
                <div className="home" style={{ textAlign: "left", padding: "20px 20px" }}>
                  <h2>Welcome to Asset Authentic Provenance!</h2>
                  <p>Select an option to start with.</p>
                </div>
              }
            />

            {/* App routes */}
            <Route path="/program" element={<ApTokenCollection />} />
            <Route path="/mint-ap-token" element={<MintApToken />} />
            <Route path="/record-event" element={<RecordEvent />} />
            <Route path="/tokens" element={<ViewToken />} />
            <Route path="/tokens/:tokenId" element={<TokenDetail mode="token" />} />
            <Route path="/tokens/:tokenId/events" element={<TokenDetail mode="event" />} />
            <Route path="/track/:tokenId" element={<TrackProvenance />} />
            {/* fallback 404 */}
            <Route path="*" element={<div>404 — Page Not Found</div>} />
          </Routes>
        </div>

        {/* Footer for ApToken */}
        <Footer />
      </Router>
    </WalletProvider>
  );
};

export default App;